// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperMain_root__UuvHa"};